import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { AdminPageHeader, Field, Toggle, ConfirmDeleteButton } from "./_helpers";
import { toast } from "sonner";

function slugify(s) {
  return (s || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
}

export default function AdminTaxonomy() {
  const [cats, setCats] = useState([]);
  const [tags, setTags] = useState([]);
  const [newCat, setNewCat] = useState({ name: "", slug: "", color: "#e11d2a", is_active: true, sort_order: 0 });
  const [newTag, setNewTag] = useState({ name: "", slug: "", is_active: true });
  const load = () => {
    api.get("/categories").then((r) => setCats(r.data));
    api.get("/tags").then((r) => setTags(r.data));
  };
  useEffect(load, []);

  const addCat = async () => {
    try { await api.post("/categories", { ...newCat, slug: newCat.slug || slugify(newCat.name) }); setNewCat({ name: "", slug: "", color: "#e11d2a", is_active: true, sort_order: 0 }); load(); toast.success("Eklendi"); } catch { toast.error("Hata"); }
  };
  const delCat = async (id) => { try { await api.delete(`/categories/${id}`); load(); } catch { toast.error("Hata"); } };
  const addTag = async () => {
    try { await api.post("/tags", { ...newTag, slug: newTag.slug || slugify(newTag.name) }); setNewTag({ name: "", slug: "", is_active: true }); load(); toast.success("Eklendi"); } catch { toast.error("Hata"); }
  };
  const delTag = async (id) => { try { await api.delete(`/tags/${id}`); load(); } catch { toast.error("Hata"); } };

  return (
    <div>
      <AdminPageHeader title="Kategori & Tag Yönetimi" />
      <div className="grid lg:grid-cols-2 gap-5">
        <div className="bg-white border border-gray-100 rounded-lg p-4">
          <h3 className="font-bold mb-3">Kategoriler</h3>
          <div className="space-y-2">
            {cats.map((c) => (
              <div key={c.id} className="flex items-center justify-between py-1.5 border-b">
                <div className="flex items-center gap-2"><span className="w-3 h-3 rounded" style={{ background: c.color }}></span><span className="text-sm font-medium">{c.name}</span><span className="text-xs text-gray-400">{c.slug}</span></div>
                <ConfirmDeleteButton onConfirm={() => delCat(c.id)} />
              </div>
            ))}
          </div>
          <div className="mt-3 grid grid-cols-2 gap-2">
            <Field label="Ad" value={newCat.name} onChange={(e) => setNewCat({ ...newCat, name: e.target.value })} />
            <Field label="Renk" type="color" value={newCat.color} onChange={(e) => setNewCat({ ...newCat, color: e.target.value })} />
          </div>
          <button onClick={addCat} className="mt-2 px-4 py-1.5 bg-[#e11d2a] text-white rounded text-sm">Ekle</button>
        </div>
        <div className="bg-white border border-gray-100 rounded-lg p-4">
          <h3 className="font-bold mb-3">Etiketler</h3>
          <div className="flex flex-wrap gap-1.5">
            {tags.map((t) => (
              <div key={t.id} className="inline-flex items-center gap-1 px-2 py-1 bg-gray-100 rounded-full text-xs">
                {t.name} <button onClick={() => delTag(t.id)} className="text-red-500">×</button>
              </div>
            ))}
          </div>
          <div className="mt-3 flex gap-2">
            <input value={newTag.name} onChange={(e) => setNewTag({ ...newTag, name: e.target.value })} placeholder="Yeni etiket" className="flex-1 px-3 py-1.5 border border-gray-200 rounded text-sm" />
            <button onClick={addTag} className="px-3 py-1.5 bg-[#e11d2a] text-white rounded text-sm">Ekle</button>
          </div>
        </div>
      </div>
    </div>
  );
}
